import React from 'react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/919034700144?text=Hi%2C%20I%20want%20to%20enquire%20about%20admissions%20at%20Cambridge%20International%20Sr.%20Sec.%20School"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[90] flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#1eb855] hover:scale-110 transition-transform duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp text-3xl"></i>
      {/* Optional: Add a pulse animation behind the button */}
      <span className="absolute inset-0 rounded-full border border-[#25D366] animate-ping opacity-75"></span>
    </a>
  );
};

export default WhatsAppButton;
